import { render, staticRenderFns } from "./ScoreStartMachineSubjectRank.vue?vue&type=template&id=77b1f972&"
import script from "./ScoreStartMachineSubjectRank.vue?vue&type=script&lang=js&"
export * from "./ScoreStartMachineSubjectRank.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStartMachineSubjectRank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports